module.exports = __webpack_public_path__ + "static/img/pic12.5192356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic12.png
// module id = piXk
// module chunks = 0